define('Store.Item.QuantityPricing.Collection', [
    'Backbone.CachedCollection',
    'Utils'
], function StoreItemQuantityPricingModel(
    CachedCollection,
    Utils
) {
    'use strict';

    return CachedCollection.extend({
        url: Utils.getAbsoluteUrl(getExtensionAssetsPath('services/Store.Item.QuantityPricing.Service.ss'))
    });
});
